import styled, { useTheme } from 'styled-components';
import { Heading2Text } from '../../../../components/Texts';
import ColorizedSpan from '../../../../components/Colorized';
import GiftCardsScroll from './GiftCardsScroll';
import { PHONE_MEDIA_QUERY } from '../../../../common/responsive';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: fit-content;
  min-height: 750px;
  gap: 30px;
  @media ${PHONE_MEDIA_QUERY} {
    min-height: unset;
    overflow: hidden;
    padding-top: 120px;
    padding-bottom: 120px;
  }
`;

const SubTitle = styled.p`
  font-size: 18px;
  font-weight: 400;
  color: ${({ theme }) => theme.text.title};
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  @media ${PHONE_MEDIA_QUERY} {
    gap: 0px;
  }
`;

const MostPopular = () => {
  const theme = useTheme();

  return (
    <Container>
      <TitleContainer>
        <Heading2Text style={{ color: theme.text.title }}>
          Most Popular <ColorizedSpan>Gifts</ColorizedSpan>
        </Heading2Text>
        <SubTitle style={{ color: theme.text.regular }}>
          From stocks and bitcoin to meme coins.
        </SubTitle>
      </TitleContainer>
      <GiftCardsScroll />
    </Container>
  );
};

export default MostPopular;
